const dragDropEngine = {
	// when a drag starts this function provides the data to use when the drag ends
	rowSourceProvider: undefined,

	// when a drag ends this function applies the change using the data gained from rowSourceProvider
	rowTargetProvider: undefined,

	setProviders: (rowSource, rowTarget) => {
		dragDropEngine.rowSourceProvider = rowSource;
		dragDropEngine.rowTargetProvider = rowTarget;
	},
};
export default dragDropEngine;

export const rowSource = {
	beginDrag(props) {
		return dragDropEngine.rowSourceProvider ? dragDropEngine.rowSourceProvider(props) : {};
	}
};

export function collectSource(connect, monitor) {
	return {
		connectDragSource: connect.dragSource(),
		isDragging: monitor.isDragging()
	}
}

export const rowTarget = {
	drop(props, monitor) {
		return dragDropEngine.rowTargetProvider ? dragDropEngine.rowTargetProvider(props, monitor) : {};
	}
};

export function collectTarget(connect, monitor) {
	return {
		connectDropTarget: connect.dropTarget(),
		isOver: monitor.isOver()
	};
}
